import React, { useState } from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import welcome from "../../assets/img/secciones/Fondo2.webp";

function VirtualTour() {
  const [loading360, setLoading360] = useState(true);
  const [loading3D, setLoading3D] = useState(true);

  return (
    <Box
      id="virtual-tour"
      sx={{
        backgroundImage: `url(${welcome})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "white",
        py: 8,
        minHeight: "85vh",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ fontFamily: "Montserrat, sans-serif", fontWeight: "bold", textAlign: "center" }}
        >
          Recorrido Virtual
        </Typography>
        <Box mt={2} mb={6} textAlign="center">
          <Typography variant="body1" color="white">
            Explora el museo interactivo con nuestro recorrido virtual
            desde la comodidad de tu casa.
          </Typography>
          <Typography variant="body1" color="white" fontWeight="bold">
            ¡Una experiencia única te espera!
          </Typography>
        </Box>

        <Grid container spacing={6}>
          {/* Video Introducción */}
          <Grid item xs={12}>
            <Box sx={{ overflow: "hidden", borderRadius: 2, boxShadow: 3 }}>
              <iframe
                width="100%"
                height="500px"
                src="https://www.youtube.com/embed/a52RB0zvQPI?si=XxREpyRzGi-273gY"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </Box>
          </Grid>

          {/* Vista Museo 360 */}
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              Vista 360° del Museo
            </Typography>
            <Box 
              sx={{ 
                position: "relative", 
                minHeight: "500px", 
                bgcolor: 'rgba(0,0,0,0.1)', 
                borderRadius: 2, 
                overflow: "hidden",
                border: "1px solid rgba(255,255,255,0.2)"
              }}
            >
              {loading360 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    bgcolor: "rgba(0,0,0,0.6)",
                    zIndex: 2,
                    flexDirection: "column",
                    gap: 2
                  }}
                >
                  <CircularProgress color="secondary" />
                  <Typography variant="body2">Cargando recorrido 360°...</Typography>
                </Box>
              )}
              <iframe
                src="https://hydroplay.mx/rv/index.html"
                width="100%"
                height="600px"
                style={{ border: 0 }}
                allowFullScreen
                onLoad={() => setLoading360(false)}
                title="Recorrido Virtual 360"
              />
            </Box>
          </Grid>

          {/* Vista Museo 3D */}
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
              Vista del Museo en 3D
            </Typography>
            <Box 
              sx={{ 
                position: "relative", 
                minHeight: "500px", 
                bgcolor: 'rgba(0,0,0,0.1)', 
                borderRadius: 2, 
                overflow: "hidden",
                border: "1px solid rgba(255,255,255,0.2)"
              }}
            >
              {loading3D && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    bgcolor: "rgba(0,0,0,0.6)",
                    zIndex: 2,
                    flexDirection: "column",
                    gap: 2
                  }}
                >
                  <CircularProgress color="secondary" />
                  <Typography variant="body2">Cargando vista 3D...</Typography>
                </Box>
              )}
              <iframe
                src="https://hydroplay.mx/INDEX/index.html"
                width="100%"
                height="600px"
                style={{ border: 0 }}
                allowFullScreen
                onLoad={() => setLoading3D(false)}
                title="Vista Museo 3D"
              />
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}

export default VirtualTour;
